import {
  cilFile,
  cilFolderOpen,
  cilLibraryAdd,
  cilPencil,
  cilSettings,
  cilTrash,
  cilWarning,
} from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import {
  CButton,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import { queryClient } from "../index";
import { Qrdetaildata, deleteorderByIdApi } from "./Helper/order";
import "./qrcode.css";

const QrScanDetails = ({ qrData, onReset }) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState(null);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const getOrderData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const res = await Qrdetaildata(qrData);

      if (res?.data) {
        const processedData = {
          ...res.data,
          isComplete: res.data.isComplete || "0",
          isSent: res.data.isSent || "0",
          isReturn: res.data.isReturn || "0",
          customerName: res.data.customerName || "N/A",
          customerPhone: res.data.customerPhone || "N/A",
          orderId: res.data.orderId || "N/A",
          orderDate: res.data.orderDate || "N/A",
          totalCharges: res.data.totalCharges || "0",
          customerId: res.data.customerId || "",
          orderItems: res.data.orderItems || []
        };
        setData(processedData);
      } else {
        setData(null);
        setError("No order data found for this QR code.");
      }
    } catch (error) {
      setData(null);
      setError("Error loading order data. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (qrData) getOrderData();
  }, [qrData]);


  const deleteOrder = async () => {
    if (!data || !data.orderId || data.orderId === "N/A") {
      swal("Error", "Invalid Order ID", "error");
      return;
    }

    swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete Order #${data.orderId}`,
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete Order"],
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setIsLoading(true);
          setDeleteStatus(null);

          const payloadData = {
            orderId: data.orderId
          };

          const response = await deleteorderByIdApi(payloadData);

          if (response.status === 200) {
            setDeleteStatus({
              type: 'success',
              message: response.message || "Order deleted successfully"
            });


            if (queryClient) {
              queryClient.invalidateQueries(["order-data-list"]);
              queryClient.invalidateQueries(["customer-data"]);
              queryClient.invalidateQueries(["dashboard-cards"]);
              queryClient.invalidateQueries(["unsent-orderdata"]);
              queryClient.invalidateQueries(["items-not-picked-list"]);
              queryClient.invalidateQueries(["received-data-list"]);
              queryClient.invalidateQueries(["outstanding-list"]);
              queryClient.invalidateQueries(["weekly-order-list"]);
              queryClient.invalidateQueries(["yesterday-order-list"]);
            }

            setTimeout(() => {
              setData(null);
              setDeleteStatus(null);
              onReset();
            }, 2000);

          } else if (response.status === 300) {
            setDeleteStatus({
              type: 'warning',
              message: response.message || "No data found"
            });

            setTimeout(() => {
              setData(null);
              setDeleteStatus(null);
              onReset();
            }, 3000);

          } else {
            setDeleteStatus({
              type: 'error',
              message: response.message || "Failed to delete order"
            });
          }
        } catch (error) {
          setDeleteStatus({
            type: 'error',
            message: "An error occurred while deleting the order"
          });
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  return (
    <div className="qr-scanner-details">
      {isLoading && !data && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Loading order details...</p>
        </div>
      )}

      {/* Error State */}
      {error && !data && !isLoading && (
        <div className="text-center py-5">
          <CIcon icon={cilWarning} size="xxl" className="text-warning mb-3" />
          <h5 className="text-warning mb-3">Order Not Found</h5>
          <p className="text-muted">{error}</p>
          <button className="btn btn-primary mt-3" onClick={onReset}>
            Scan Again
          </button>
        </div>
      )}

      {deleteStatus && (
        <div className={`alert alert-${deleteStatus.type === 'success' ? 'success' : deleteStatus.type === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`} role="alert">
          <CIcon icon={cilWarning} className="me-2" />
          {deleteStatus.message}
          <button type="button" className="btn-close" onClick={() => setDeleteStatus(null)}></button>
        </div>
      )}

      {/* Order Data Display */}
      {data && !deleteStatus && (
        <>
          <div className="text-center mb-4">
            <h3>INVOICE</h3>
          </div>

          <div className="mt-4">
            <h5 className="mb-3">Order Details</h5>

            <div id="table_div" className="data-table-wrapper">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th style={{ border: '0.5px solid #999', padding: '8px', textAlign: 'center' }}>No</th>
                    <th style={{ border: '0.5px solid #999', padding: '8px' }}>Actions</th>
                    <th style={{ border: '0.5px solid #999', padding: '8px' }}>Order No</th>
                    <th style={{ border: '0.5px solid #999', padding: '8px' }}>Customer</th>
                    <th style={{ border: '0.5px solid #999', padding: '8px', textAlign: 'center' }}>Complete</th>
                    <th style={{ border: '0.5px solid #999', padding: '8px', textAlign: 'center' }}>Sent</th>
                    <th style={{ border: '0.5px solid #999', padding: '8px' }}>Order Date</th>
                    <th style={{ border: '0.5px solid #999', padding: '8px' }}>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ border: '0.5px solid #999', padding: '8px', textAlign: 'center' }}>1</td>
                    <td style={{ border: '0.5px solid #999', padding: '8px' }}>
                      <div className="action-buttons" ref={dropdownRef} style={{ display: 'flex', gap: '9px', height: '35px' }}>
                        <CButton
                          color="success"
                          variant="outline"
                          className="action-btn"
                          title="Add Outstanding"
                          onClick={() =>
                            navigate("/actionoutstanding", {
                              state: {
                                orderId: data.orderId || "",
                                customerId: data.customerId || "",
                                customerName: data.customerName || "",
                              },
                            })
                          }
                          size="sm"
                        >
                          <CIcon icon={cilLibraryAdd} size="lg" />
                        </CButton>

                        <div className="qr-dropdown-container">
                          <CDropdown variant="btn-group" alignment="end" popper={true}>
                            <CDropdownToggle color="dark" className="qr-dropdown-toggle action-btn">
                              <CIcon icon={cilSettings} />
                            </CDropdownToggle>
                            <CDropdownMenu className="qr-dropdown-menu">
                              <Link
                                to={`/order/${data.orderId || ""}`}
                                className="text-decoration-none"
                                onClick={(e) => {
                                  if (!data.orderId || data.orderId === "N/A") {
                                    e.preventDefault();
                                    alert("Invalid Order ID");
                                  }
                                }}
                              >
                                <CDropdownItem className="qr-dropdown-item">
                                  <div className="d-flex align-items-center">
                                    <CIcon icon={cilPencil} className="me-2" />
                                    <span>Edit</span>
                                  </div>
                                </CDropdownItem>
                              </Link>

                              <Link
                                to={`/view/${data.orderId || ""}`}
                                className="text-decoration-none"
                                onClick={(e) => {
                                  if (!data.orderId || data.orderId === "N/A") {
                                    e.preventDefault();
                                    alert("Invalid Order ID");
                                  }
                                }}
                              >
                                <CDropdownItem className="qr-dropdown-item">
                                  <div className="d-flex align-items-center">
                                    <CIcon icon={cilFolderOpen} className="me-2" />
                                    <span>View</span>
                                  </div>
                                </CDropdownItem>
                              </Link>

                              <CDropdownItem
                                className="qr-dropdown-item"
                                onClick={() => {
                                  if (data.orderId && data.orderId !== "N/A") {
                                    window.open(
                                      `${process.env.REACT_APP_BASE_URL?.replace('/api', '')}opr/${data.orderId}`,
                                      "_blank"
                                    );
                                  } else {
                                    alert("Cannot print: Invalid Order ID");
                                  }
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <CIcon icon={cilFile} className="me-2" />
                                  <span>Print</span>
                                </div>
                              </CDropdownItem>

                              {/* Delete Order Button */}
                              <CDropdownItem
                                className="qr-dropdown-item text-danger"
                                onClick={deleteOrder}
                                disabled={isLoading}
                              >
                                <div className="d-flex align-items-center">
                                  <CIcon icon={cilTrash} className="me-2" />
                                  <span>{isLoading ? "Deleting..." : "Delete Order"}</span>
                                </div>
                              </CDropdownItem>
                            </CDropdownMenu>
                          </CDropdown>
                        </div>
                      </div>
                    </td>
                    <td style={{ border: '1px solid #999', padding: '8px' }}>{data.orderId || "N/A"}</td>
                    <td style={{ border: '1px solid #999', padding: '8px' }}>
                      {data.customerName || "N/A"} (Ph. {data.customerPhone || "N/A"})
                    </td>
                    <td style={{ border: '1px solid #999', padding: '8px', textAlign: 'center' }}>
                      <span
                        className="badge"
                        style={{
                          backgroundColor: (data.isComplete || "0") === "1" ? "lightgreen" : "lightpink",
                          color: (data.isComplete || "0") === "1" ? "#006400" : "red",
                          padding: '4px 8px',
                          display: 'inline-block',
                          fontSize: '14px',
                          borderRadius: '3px',
                        }}
                      >
                        {(data.isComplete || "0") === "1" ? "Yes" : "No"}
                      </span>
                    </td>
                    <td style={{ border: '1px solid #999', padding: '8px', textAlign: 'center' }}>
                      <span
                        className="badge"
                        style={{
                          backgroundColor: (data.isSent || "0") === "1" ? "lightgreen" : "lightpink",
                          color: (data.isSent || "0") === "1" ? "#006400" : "red",
                          padding: '4px 8px',
                          display: 'inline-block',
                          fontSize: '14px',
                          borderRadius: '3px',
                        }}
                      >
                        {(data.isSent || "0") === "1" ? "Yes" : "No"}
                      </span>
                    </td>
                    <td style={{ border: '1px solid #999', padding: '8px' }}>{data.orderDate || "N/A"}</td>
                    <td style={{ border: '1px solid #999', padding: '8px' }}>{data.totalCharges || "0"} Rs</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="text-end mt-3">
            <button className="btn btn-primary" onClick={onReset}>
              Scan Again
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default QrScanDetails;